import { Component, OnInit, Input, ChangeDetectorRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { PartnerService } from 'app/services/partner-service';
import { ToastrService } from 'ngx-toastr';
import { HousingUnitService } from "app/services/housingunit-service";
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { ITreatmentData } from 'app/models/household/treatment';
import { trigger, transition, style, animate } from '@angular/animations';
import { Observable } from 'rxjs/internal/Observable';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-partners-lubgwma-plumbers',
  templateUrl: './lubgwma-plumber.component.html',
  styleUrls: ['./lubgwma-plumber.component.scss'],
  providers: [PartnerService],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease-in', style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class PartnersLubgwmaPlumbersComponent implements OnInit {
  @Input('partnerId')
  partnerId: number = 0;


  @Input('accessGuid')
  accessGuid: string = '';

  @Input('passKey')
  passKey: string = '';

  searchText: string = 'test';
  treatmentId: number = 0;
  completedTreatmentId: number = 0;
  loading: boolean = true;
  processing: boolean = false;

  treatmentData: ITreatmentData = {
    sharedWell: false,
    highestNitrateTestResult: 0,
    lastSampleCollectionDate: "",
    dateOfFirstTier3Sample: "",
    dateOfHighestNitrateResult: "",
  };

  partnerTreatment: any = {
    treatmentId: 0,
    city: "",
    address: "",
    mailingCity: "",
    mailingState: "",
    mailingAddress: "",
    mailingZip: "",
    existingTreatmentSystem: "",
    systemInstallationPriority: "",
    housingUnitId: 0,
    roSystemRefused: false,
    systemInstalled: "",
    statusOfInstall: "",
    treatmentInstallCompletionDate: null,
    latestFilterChangeDate: null,
    reasonForRefusal: "",
    installedBy: "",
    describeExistingSystem: "",
    treatmentData: this.treatmentData,
  };

  treatmentForm = new FormGroup({
    treatmentId: new FormControl(''),
    completedTreatmentId: new FormControl(''),
    systemInstalled: new FormControl(''),
    statusOfInstall: new FormControl(''),
    treatmentInstallCompletionDate: new FormControl(null),
    installedBy: new FormControl(''),
  });

  treatments: typeof this.partnerTreatment[] = [];
  pendingTreatments: typeof this.partnerTreatment[] = [];
  completedTreatments: typeof this.partnerTreatment[] = [];
  pendingTreatmentsControl = new FormControl('');
  completedTreatmentsControl = new FormControl('');
  filteredPendingTreatments: Observable<any[]>;
  filteredCompletedTreatments: Observable<any[]>;

  constructor(
    public partnerService: PartnerService,
    public housingUnitService: HousingUnitService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {
    this.partnerService.accessGuid = this.accessGuid;
    this.partnerService.passKey = this.passKey;
    this.loadTreatments();
  }

  loadTreatments() {
    this.processing = true;

    if (this.partnerId > 0) {
      this.partnerService.getPartnerTreatments(this.partnerId).subscribe(
        (result) => {
          this.treatments = result;
          this.pendingTreatments = this.treatments.filter(treatment => treatment.statusOfInstall != 'Installed');
          this.filteredPendingTreatments = this.pendingTreatmentsControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filteredPendingTreatments(value || '')),
          );

          this.completedTreatments = this.treatments.filter(treatment => treatment.statusOfInstall === 'Installed');
          this.filteredCompletedTreatments = this.completedTreatmentsControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filteredCompletedTreatments(value || '')),
          );
          this.processing = false;
          this.cd.detectChanges();
        },
        (error) => {
          this.toastr.error("Unable to load Treatments");
          this.processing = false;
        }
      );
    } else {
      this.processing = false;
    }
  }

  private _filteredPendingTreatments(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.pendingTreatments.filter(option => option.address.toLowerCase().includes(filterValue));
  }

  private _filteredCompletedTreatments(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.completedTreatments.filter(option => option.address.toLowerCase().includes(filterValue));
  }

  loadTreatment(treatmentId) {
    this.processing = true;
    this.resetPartnerSelection();

    //add 1 sec delay
    setTimeout(() => {
      this.treatmentId = treatmentId;
      this.getPartnerTreatment();
    }, 500);
  }

  resetPartnerSelection() {
    this.partnerTreatment = null;
    this.treatmentId = null;
    if (this.treatmentForm.get('treatmentId') && !this.treatmentForm.get('treatmentId').touched && this.treatmentForm.get('treatmentId').value) {
      this.treatmentForm.get('completedTreatmentId').reset();
    }

    if (this.treatmentForm.get('completedTreatmentId') && !this.treatmentForm.get('completedTreatmentId').touched && this.treatmentForm.get('completedTreatmentId').value) {
      this.treatmentForm.get('treatmentId').reset();
    }
  }

  setFormValues() {
    this.treatmentForm.get("statusOfInstall").setValue(this.partnerTreatment.statusOfInstall);
    this.treatmentForm.get("installedBy").setValue(this.partnerTreatment.installedBy);
    this.treatmentForm.get("systemInstalled").setValue(this.partnerTreatment.systemInstalled);
    this.treatmentForm.get("treatmentInstallCompletionDate")
      .setValue(
        this.partnerTreatment.treatmentInstallCompletionDate
          ? new Date(
            this.partnerTreatment.treatmentInstallCompletionDate
          ).toISOString()
          : new Date().toISOString()
      );
    this.partnerTreatment.treatmentId = this.treatmentId;
  }

  getFormValues() {
    this.partnerTreatment.systemInstalled = this.treatmentForm.value.systemInstalled;
    this.partnerTreatment.statusOfInstall = this.treatmentForm.value.statusOfInstall;
    this.partnerTreatment.treatmentInstallCompletionDate = this.treatmentForm.value
      .treatmentInstallCompletionDate
      ? new Date(
        this.treatmentForm.value.treatmentInstallCompletionDate
      ).toISOString()
      : null;
    this.partnerTreatment.installedBy = this.treatmentForm.value.installedBy;
  }

  getPartnerTreatment() {
    if (this.treatmentId > 0) {
      this.partnerTreatment = this.treatments.filter(treatment => treatment.treatmentId === this.treatmentId)[0];
      this.processing = false;
      this.setFormValues();
      this.cd.detectChanges();
      /* this.housingUnitService.getTreatment(this.treatmentId).subscribe(
        (result) => {
          this.partnerTreatment = result;
          console.log(this.partnerTreatment);
          this.cd.detectChanges();
        },
        (error) => {
          this.toastr.error("Unable to load Treatment");
          this.loading = false;
        }
      ); */
    } else {
      this.processing = false;
    }
  }

  submitTreatment() {
    this.processing = true;
    this.getFormValues();
    this.partnerService.savePartnerTreatment(this.partnerTreatment).subscribe(
      (result) => {
        this.processing = false;
        this.toastr.success('Treatment saved successfully');
        this.resetPartnerSelection();
        this.treatmentForm.get('treatmentId').reset();
        this.treatmentForm.get('completedTreatmentId').reset();
        this.loadTreatments();
      },
      (error) => {
        this.processing = false;
        this.toastr.error('Error saving treatment: ' + error.message);
        console.error('Error saving treatment:', error);
      }
    );
  }

  searchHousingUnits() {
    console.log(this.searchText);
    this.partnerService.lubgwmaPlumbersSearch(this.searchText).subscribe(
      (result) => {
        //console.log(result);
        this.toastr.success('Search successful');
      },
      (error) => {
        this.toastr.error('Search unsuccessful: ' + error.message);
        console.error('Error searching housing units:', error);
      }
    );
  }

}